export default "<div class=\"k-card-footer\" ng-transclude></div>"